module.exports = __webpack_public_path__ + "static/assets/b15c0ce33471af837eb2fb06ab3ce597.png";